var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "pa-3 card-mensageria" },
    [
      _c(
        "v-row",
        [
          _c("v-col", [
            _c("h4", { staticClass: "bold" }, [_vm._v("Mensageria")])
          ])
        ],
        1
      ),
      _c(
        "v-row",
        { staticClass: "mt-0" },
        [
          _c("v-col", [
            _c("div", { staticClass: "list-alert" }, [
              _vm.superUsuario && _vm.usuarioRecuperi
                ? _c(
                    "div",
                    [
                      _c("v-icon", { attrs: { color: _vm.alertTypeEmail } }, [
                        _vm._v(
                          _vm._s(
                            _vm.alertTypeEmail === "success"
                              ? "mdi-check-circle"
                              : "mdi-alert-circle"
                          )
                        )
                      ]),
                      _c("span", {
                        staticClass: "ml-2",
                        domProps: { innerHTML: _vm._s(_vm.alertInfoEmail) }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.superUsuario && _vm.usuarioRecuperi
                ? _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c("v-icon", { attrs: { color: _vm.alertTypeCel } }, [
                        _vm._v(
                          _vm._s(
                            _vm.alertTypeCel === "success"
                              ? "mdi-check-circle"
                              : "mdi-alert-circle"
                          )
                        )
                      ]),
                      _c("span", {
                        staticClass: "ml-2",
                        domProps: { innerHTML: _vm._s(_vm.alertInfoCel) }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.superUsuario && _vm.usuarioRecuperi
                ? _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "v-icon",
                        { attrs: { color: _vm.alertTypeCelCheck } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.alertTypeCelCheck === "success"
                                ? "mdi-check-circle"
                                : "mdi-alert-circle"
                            )
                          )
                        ]
                      ),
                      _c("span", {
                        staticClass: "ml-2",
                        domProps: { innerHTML: _vm._s(_vm.alertInfoCelCheck) }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm.superUsuario && _vm.usuarioRecuperi
                ? _c(
                    "div",
                    { staticClass: "mt-2" },
                    [
                      _c(
                        "v-icon",
                        {
                          attrs: {
                            color: _vm.habilitadoNotifica ? "success" : "info"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.habilitadoNotifica === "success"
                                ? "mdi-check-circle"
                                : "mdi-alert-circle"
                            )
                          )
                        ]
                      ),
                      _vm.habilitadoNotifica
                        ? _c("span", {
                            staticClass: "ml-2",
                            domProps: {
                              innerHTML: _vm._s(
                                "<strong>Notifica:</strong> o Apresentante está habilitado na Notifica"
                              )
                            }
                          })
                        : _c("span", {
                            staticClass: "ml-2",
                            domProps: {
                              innerHTML: _vm._s(
                                "<strong>Notifica:</strong> o Apresentante não está habilitado na Notifica"
                              )
                            }
                          })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }